import Api from '@/api/index';

const EmployeeRole = {
  namespaced: true,
  state: {
    oneRole: null,
    allRoles: null,
    errorMessage: null,
    errorActive: null,
  },
  mutations: {
    getRoles(state, {role}){
      state.allRoles = role.data;
    },
    getOneRole(state, role){
      state.oneRole = role.data;
    },

    setErrorMessage(state, {message, status}) {
      state.errorMessage = message;
      state.errorActive = status;
    }
  },
  actions: {
    index(context){
      Api.EmployeeRole.index()
        .then(response => response.data)
        .then(role => {
          context.commit('getRoles', {role: role})
          context.commit('setErrorMessage', {message: '',status: false})
        }).catch(function(error) {
          console.log(error);
        })
    },
  }
};

export default EmployeeRole;